<template>
    <v-expansion-panels v-model="collapse">
        <v-expansion-panel>
            <v-expansion-panel-header><h3 class="font-weight-bold">{{ $t('common.filter.componentName') }}</h3></v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-container fluid>
                    <v-row v-if="
                        selects.client.show ||
                        selects.department.show ||
                        selects.manager.show
                    ">
                        <v-col cols="12" md="4" v-if="selects.client.show">
                            <input-auto-complete :setup.sync="selects.client"></input-auto-complete>
                        </v-col>

                        <v-col cols="12" md="4" v-if="selects.department.show">
                            <input-auto-complete :setup.sync="selects.department"></input-auto-complete>
                        </v-col>

                        <v-col cols="12" md="4" v-if="selects.manager.show">
                            <input-auto-complete :setup.sync="selects.manager"></input-auto-complete>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="3">
                            <input-date-picker :setup.sync="datePickers.fromDate"></input-date-picker>
                        </v-col>

                        <v-col cols="12" md="3">
                            <input-date-picker :setup.sync="datePickers.toDate"></input-date-picker>
                        </v-col>

                        <v-col cols="12" md="3">
                            <input-auto-complete :setup.sync="selects.responsible"></input-auto-complete>
                        </v-col>

                        <v-col cols="12" md="3">
                            <input-select :setup.sync="selects.status"></input-select>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="12">
                            <div class="d-flex justify-end">
                                <v-btn
                                    color="error"
                                    class="mr-1"
                                    text
                                    small
                                    :disabled="!ready"
                                    @click="clearFilters"
                                >{{ $t('common.filter.clearFilter') }}</v-btn>
                                <v-btn
                                    color="primary"
                                    class="ml-1"
                                    small
                                    :disabled="!ready"
                                    @click="applyFilters"
                                >{{ $t('common.filter.applyFilter') }}</v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import InputDatePicker from '@/components/InputDatePicker'
import InputAutoComplete from '@/components/InputAutoComplete'
import InputSelect from '@/components/InputSelect'

export default {
    name: 'demand-filter',
    props: ['filters'],
    components: {
        InputDatePicker,
        InputAutoComplete,
        InputSelect
    },
    data () {
        return {
            collapse: 0,
            ready: false,
            type: '',
            datePickers: {
                fromDate: {
                    label: this.$t('demand.list.filter.fromDate'),
                    clearable: true,
                    dateFormatted: undefined
                },
                toDate: {
                    label: this.$t('demand.list.filter.toDate'),
                    clearable: true,
                    dateFormatted: undefined
                }
            },
            selects: {
                client: {
                    label: this.$t('demand.list.filter.client'),
                    text: 'name',
                    value: 'objectId',
                    icon: 'contacts',
                    multiple: true,
                    clearable: true,
                    items: [],
                    selectedItems: [],
                    show: false
                },
                department: {
                    label: this.$t('demand.list.filter.department'),
                    text: 'name',
                    value: 'objectId',
                    icon: 'contacts',
                    multiple: true,
                    clearable: true,
                    items: [],
                    selectedItems: [],
                    show: false
                },
                manager: {
                    label: this.$t('demand.list.filter.manager'),
                    text: 'manager.name',
                    value: 'manager.objectId',
                    icon: 'contacts',
                    multiple: true,
                    clearable: true,
                    items: [],
                    selectedItems: [],
                    show: false
                },
                responsible: {
                    label: this.$t('demand.list.filter.responsible'),
                    text: 'user.name',
                    value: 'objectId',
                    icon: 'person',
                    multiple: true,
                    clearable: true,
                    items: [],
                    selectedItems: [],
                    show: false
                },
                status: {
                    label: this.$t('demand.list.filter.status'),
                    text: 'label',
                    value: 'value',
                    icon: 'feedback',
                    multiple: true,
                    clearable: true,
                    items: [
                        { value: 1, label: this.$t('demand.status.pending') },
                        { value: 2, label: this.$t('demand.status.starting') },
                        { value: 3, label: this.$t('demand.status.waiting') },
                        { value: 4, label: this.$t('demand.status.standby') },
                        { value: 5, label: this.$t('demand.status.finished') },
                        { value: 6, label: this.$t('demand.status.canceled') }
                    ],
                    selectedItems: []
                }
            }
        }
    },
    watch: {
        'filters.ready': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.ready = this.filters.ready
                }
            },
            deep: true
        }
    },
    mounted () {
        const currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
        this.type = currentUserCompany.client.type
        switch (currentUserCompany.client.type) {
        case 'company':
        case 'managed_company':
            this.selects.department.show = true
            this.selects.manager.show = true
            break
        case 'manager':
            this.selects.client.show = true
            this.selects.department.show = true
            this.selects.manager.show = true
            break
        default:
            break
        }
        this.getAllClient()
        this.getAllDepartment()
        this.getAllManager()
        this.getAllEmployee()
    },
    methods: {
        async getAllClient () {
            this.selects.client.items = await this.$helpers.getAllClient(null, false, true)
        },
        async getAllDepartment () {
            this.selects.department.items = await this.$helpers.getAllClientTwo(true, 0, 'department')
        },
        async getAllManager () {
            this.selects.manager.items = await this.$helpers.getAllManagerCompany()
        },
        async getAllEmployee () {
            this.selects.responsible.items = await this.$helpers.getAllEmployee()
            this.filterMe()
        },
        applyFilters () {
            this.filters.fromDate = (this.datePickers.fromDate.dateFormatted) ? new Date(this.datePickers.fromDate.dateFormatted.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1')).toISOString() : undefined
            this.filters.toDate = (this.datePickers.toDate.dateFormatted) ? new Date(this.datePickers.toDate.dateFormatted.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1')).toISOString() : undefined
            this.filters.client = this.selects.client.selectedItems
            this.filters.department = this.selects.department.selectedItems
            this.filters.manager = this.selects.manager.selectedItems
            this.filters.responsible = this.selects.responsible.selectedItems
            this.filters.status = this.selects.status.selectedItems
            this.filters.limit = undefined
            this.filters.skip = undefined
            this.$emit('get-data-from-api')
        },
        clearFilters () {
            this.filters.fromDate = undefined
            this.filters.toDate = undefined
            this.filters.client = []
            this.filters.department = []
            this.filters.manager = []
            this.filters.responsible = []
            this.filters.status = []
            this.filters.limit = undefined
            this.filters.skip = undefined
            this.datePickers.fromDate.date = undefined
            this.datePickers.fromDate.dateFormatted = undefined
            this.datePickers.toDate.date = undefined
            this.datePickers.toDate.dateFormatted = undefined
            this.selects.client.selectedItems = []
            this.selects.department.selectedItems = []
            this.selects.manager.selectedItems = []
            this.selects.responsible.selectedItems = []
            this.selects.status.selectedItems = []
            this.$emit('get-data-from-api')
        },
        toggleSelectItemStatus (select) {
            this.$nextTick(() => {
                if (select.selectedItems.length === select.items.length) {
                    select.selectedItems = []
                } else {
                    select.items.forEach((item) => {
                        if (select.selectedItems.indexOf(item.value) === -1) {
                            select.selectedItems.push(item.value)
                        }
                    })
                }
            })
        },
        filterMe () {
            const currentUserCompamy = JSON.parse(localStorage.currentUserCompany)
            if ((currentUserCompamy.client.type === 'manager')) {
                this.selects.responsible.selectedItems.push(currentUserCompamy.objectId)
            }
            this.applyFilters()
        },
        filterCompanies () {
            for (const client of this.selects.client.items) {
                this.selects.client.selectedItems.push(client.objectId)
            }
            this.applyFilters()
        },
        filterDepartments () {
            for (const department of this.selects.department.items) {
                this.selects.department.selectedItems.push(department.objectId)
            }
            this.applyFilters()
        },
        filterManagers () {
            for (const manager of this.selects.manager.items) {
                this.selects.manager.selectedItems.push(manager.manager.objectId)
            }
            this.applyFilters()
        }
    }
}
</script>
